
const digest = '46fa81bc4f0269a765d5cdfa6817b64af949d1aafd191dd077e0ada9326ca91b';
const classes = {"title":"_title_2xbk3_1","subtitle":"_subtitle_2xbk3_7","category":"_category_2xbk3_14"};
const css = `._title_2xbk3_1 {
  font-weight: 500;
  color: #000000;
  margin-bottom: 5px;
}

._subtitle_2xbk3_7 {
  font-weight: 500;
  color: #000000;
  margin-bottom: 10px;
  font-size: 14px;
}

._category_2xbk3_14 {
  font-weight: 500;
  font-size: 16px;
  background-color: #1d65d8;
  padding: 6px 12px;
  border-radius: 5px;
  color: #ffffff;
  margin-bottom: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  